import ActivitiesShell from "../components/activities/ActivitiesShell";
import { Link } from "react-router-dom";

export default function ActivitiesEvents() {
  return (
    <ActivitiesShell
      introTitle="Upcoming events for our members and families."
      introSubtitle="See what is coming up next. Some events are open to everyone, while a few are kept for approved members and invited families."
    >
      <div className="card-premium">
        <div className="overline mb-4">Upcoming events</div>
        <div className="rounded-2xl border border-black/5 bg-cream-deep/60 p-5">
          <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-4">
            <div>
              <h2 className="font-heading text-2xl text-ink">New Event</h2>
              <p className="mt-2 text-sm text-ink-soft leading-relaxed">
                Registration is open. Share this link directly in WhatsApp groups,
                no sign in required.
              </p>
              <div className="mt-4 text-sm text-ink-muted">
                Coming soon · OSPF Udaipur
              </div>
            </div>
            <Link
              to="/events/new-event/register"
              className="btn-primary inline-flex justify-center shrink-0"
            >
              Register now
            </Link>
          </div>
        </div>
      </div>
    </ActivitiesShell>
  );
}
